import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StepsRoutingModule } from './steps-routing.module';
import { NavbarModule } from '../navbar/navbar.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingModule } from '../loading/loading.module';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTableModule } from '@angular/material/table';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';

import { StepsComponent } from './steps/steps.component';
import { StepsDataComponent } from './steps-data/steps-data.component';
import { StepsHeaderComponent } from './steps-header/steps-header.component';
import { StepsSummaryComponent } from './steps-summary/steps-summary.component';
import { StepsDataEmptyComponent } from './steps-data-empty/steps-data-empty.component';
import { StepsDataTableComponent } from './steps-data-table/steps-data-table.component';
import { StepsFilterDialogComponent } from './steps-filter-dialog/steps-filter-dialog.component';
import { StepsFiltersComponent } from './steps-filters/steps-filters.component';
import { StepsSyncDialogComponent } from './steps-sync-dialog/steps-sync-dialog.component';
import { StepsQineticReloadDialogComponent } from './steps-qinetic-reload-dialog/steps-qinetic-reload-dialog.component';
import { StepsRequestsDialogComponent } from './steps-requests-dialog/steps-requests-dialog.component';

@NgModule({
  declarations: [
    StepsComponent,
    StepsDataComponent,
    StepsHeaderComponent,
    StepsSummaryComponent,
    StepsDataEmptyComponent,
    StepsDataTableComponent,
    StepsFilterDialogComponent,
    StepsFiltersComponent,
    StepsSyncDialogComponent,
    StepsQineticReloadDialogComponent,
    StepsRequestsDialogComponent,
  ],
  imports: [
    CommonModule,
    StepsRoutingModule,
    NavbarModule,
    ToolbarModule,
    TranslateModule,
    LoadingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatTableModule,
    MatDatepickerModule,
    MatExpansionModule,
  ],
})
export class StepsModule {}
